import { type AuthTokens, parseAuthCookies } from '@nutralab/api';

import { persistAuthTokens } from './persistAuthTokens';

import { LEGACY_AUTH_TOKENS_STORAGE_KEY } from '@/shared/constants';

/** The session tokens from the shared cookies (moving an older `localStorage` session there first), or `null`. */
export function readAuthTokens(): AuthTokens | null {
    const tokens = parseAuthCookies(document.cookie);
    if (tokens) {
        return tokens;
    }

    const legacy = readLegacyTokens();
    if (legacy) {
        persistAuthTokens(legacy);
    }
    return legacy;
}

function readLegacyTokens(): AuthTokens | null {
    try {
        const raw = localStorage.getItem(LEGACY_AUTH_TOKENS_STORAGE_KEY);
        const value: unknown = raw ? JSON.parse(raw) : null;
        return isAuthTokens(value) ? value : null;
    } catch {
        return null;
    }
}

function isAuthTokens(value: unknown): value is AuthTokens {
    return (
        typeof value === 'object' &&
        value !== null &&
        'access_token' in value &&
        typeof value.access_token === 'string' &&
        'refresh_token' in value &&
        typeof value.refresh_token === 'string'
    );
}
